import { useEffect, useMemo, useState } from 'react'
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import api from '../../components/api'
import { cor, corEnviado, rotulo, rotuloEnviado } from '../../components/functions'
import Badge from 'react-bootstrap/Badge';
import { format } from 'date-fns'
import LoaderIcon from "react-loader-icon";

import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'


const EnergiaEletricaCompra = (props) => {

    var { adesao_institucional_id, ano: anoProps, formulario_id } = props

    const [resultado, setResultado] = useState([])
    const [ano, setAno] = useState('')
    
    const [carregando, setCarregando] = useState('block')


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()



    const columns = useMemo(
        () => [
            
          {
            accessorKey: 'ghg_combustaoEstacionaria_id', //access nested data with dot notation
            header: 'ID',
          },
          {
            accessorKey: 'ano', //access nested data with dot notation
            header: 'Ano',
          },
           {
            accessorKey: 'situacaoCod',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },
          {
            accessorKey: 'versao',
            header: 'versao',
          },
          {
            accessorKey: 'ad_upd',
            header: 'Data atualização',
            Cell: ({ cell }) => {
                const rawValue = cell.getValue() // formato ISO
                const date = new Date(rawValue)
                return format(date, 'dd/MM/yyyy HH:mm:ss')
            },
            },
         

          {
            accessorKey: 'nomeResponsavel',
            header: 'nomeResponsavel',
          },
          
          {
            accessorKey: 'descricaoFonte',
            header: 'descricaoFonte',
          },


          {
            accessorKey: 'tipoGeracaoEnergia',
            header: 'tipoGeracaoEnergia',
          },
          

          {
            accessorKey: 'combustivel',
            header: 'combustivel',
          },
          
          {
            accessorKey: 'possuiFatorEmissao',
            header: 'possuiFatorEmissao',
          },


          {
            accessorKey: 'eficienciaPlantaGeradora',
            header: 'eficienciaPlantaGeradora',
          },
          

          {
            accessorKey: 'eletricidadeTotalComprada',
            header: 'eletricidadeTotalComprada',
            muiTableHeadCellProps: {
                align: 'right',
              },
            muiTableBodyCellProps: {
                align: 'right',
              },
          },


          {
            accessorKey: 'emissoesCO2',
            header: 'emissoesCO2',
            muiTableHeadCellProps: {
                align: 'right',
              },
            muiTableBodyCellProps: {
                align: 'right',
              },
          },
          

          {
            accessorKey: 'emissoesN2O',
            header: 'emissoesN2O',
            muiTableHeadCellProps: {
                align: 'right',
              },
            muiTableBodyCellProps: {
                align: 'right',
              },
          },



          {
            accessorKey: 'emissoesCO2E',
            header: 'emissoesCO2E',
            muiTableHeadCellProps: {
                align: 'right',
              },
            muiTableBodyCellProps: {
                align: 'right',
              },
          },



          {
            accessorKey: 'emissoesCO2Bio',
            header: 'emissoesCO2Bio',
            muiTableHeadCellProps: {
                align: 'right',
              },
            muiTableBodyCellProps: {
                align: 'right',
              },
          },
          


          
          
        ],
        [],
      );

    
    const carrega = () => {

        var dataPost = {

            adesao_institucional_id,
            ano: ano != '' ? ano : null,
            
        }

        setCarregando('block')

        api.post('energiaEletricaCompraLista', dataPost).then((result) => {

            setResultado(result.data)
            setCarregando('none')

        }).catch((err) => {

            console.log(err.response)
            setCarregando('none')

        })

    }

    useEffect(() => {

        if (anoProps) {

            setAno(anoProps)

        }
        
    }, [anoProps])

    useEffect(() => {

        carrega()

    }, [adesao_institucional_id, ano, formulario_id, verificaDesafio])



    return (

        <div>

            <div className="row">


                <div className="col-md-12">
                    
                    <div class="form-group" >
                        
                        <select className="form-control" value={ano} onChange={event => setAno(event.target.value)} >
                            <option value={anoProps}>{anoProps}</option>
                            <option value="">Todos os anos</option>
                            
                            
                        </select><br/>
                            

                    </div>

                </div>

                <div className="col-md-12" style={{ display: carregando }} >
                    <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                </div>

                <div className="col-md-12" style={{ display: carregando == 'block' ? 'none' : 'table-row'}}>

                    


                    <MaterialReactTable 
                                        
                        columns={columns} 
                        data={resultado} 
                        localization={MRT_Localization_PT_BR}
                        //rowsPerPage={20}
                        //options={options}
                        initialState={{ 
                            density: 'compact',
                            sorting: [
                                {
                                    id: 'ano', //sort by age by default on page load
                                    desc: true,
                                },
                                
                                ],
                            }}
                        muiTableHeadCellProps={{
                            //easier way to create media queries, no useMediaQuery hook needed.
                            sx: {
                            fontSize: {
                                xs: '8px',
                                sm: '9px',
                                md: '10px',
                                lg: '11px',
                                xl: '12px',
                            },
                            },
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                fontSize: {
                                xs: '8px',
                                sm: '9px',
                                md: '10px',
                                lg: '11px',
                                xl: '12px',
                                },
                            },
                        }}
                        muiTableBodyRowProps={({ row }) => ({
                        onClick: (event) => {
                            //console.info(event, row.original.usuario_id);
                            if (parseInt(row.original.ano) == parseInt(anoProps)) {
                                //setEnunciado(`id: ${row.original.ghg_combustaoEstacionaria_id}`);setSecaoEnunciado('Combustão Estacionária');window.$('#modalValidacao').modal('show')
                            }
                            
                        },
                        sx: {
                            //cursor: parseInt(row.original.ano) == parseInt(anoProps)  ? 'pointer' : 'auto', //you might want to change the cursor too when adding an onClick
                            cursor: 'auto'
                        },
                        })}
                    />


                </div>

            </div>

        </div>

    )

}

export default EnergiaEletricaCompra